"use client"

import { ComponentProps } from "react"
import { Toaster } from "react-hot-toast"

/**
 * Wrapper for Toaster to use directly inside server components
 */
export function ClientToaster({ toastOptions, containerStyle, ...restProps }: ComponentProps<typeof Toaster>) {
  return <Toaster {...restProps} containerStyle={{ position: "fixed", top: 80, zIndex: 400000, ...containerStyle }} toastOptions={{ duration: 7000, ...toastOptions }} />
}
